export default {
      id: "as-blue-badge-parking-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-blue-badge-parking",
      toString: function () {
        return this.url;
      }
    }